import { render, staticRenderFns } from "./ProductShowConfig.vue?vue&type=template&id=3b7b51e2&scoped=true&"
import script from "./ProductShowConfig.vue?vue&type=script&lang=js&"
export * from "./ProductShowConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7b51e2",
  null
  
)

export default component.exports